export default function highlightElement({
                                          $el = null,
                                          highlightClass = 'highlight',
                                          removeClass = true,
                                          done = null
                                        }): void {
  window.requestAnimationFrame(() => {
    $el.addClass(highlightClass);
    $el.on('animationend', () => {
      if (removeClass) {
        $el.removeClass(highlightClass);
      }
      if (done) {
        done();
      }
      $el.off('animationend');
    });
  })
}
